/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown>, name: NonNullable<unknown> }} Explorer_Info_Batch_Progress_StatusInputs */



/**
* | output |
* | --- |
* | "Exporting {current} of {total}: {name}" |
*
* @param {Explorer_Info_Batch_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_progress_status = /** @type {((inputs: Explorer_Info_Batch_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation de ${i?.current} de ${i?.total}: ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportiere ${i?.current} von ${i?.total}: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione di ${i?.current} di ${i?.total}: ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт ${i?.current} из ${i?.total}: ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando ${i?.current} de ${i?.total}: ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在导出 ${i?.total} 中的 ${i?.current}：${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.total} の ${i?.current} をエクスポートしています: ${i?.name}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.total} में से ${i?.current} का निर्यात: ${i?.name}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando ${i?.current} de ${i?.total}: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Exporting ${i?.current} of ${i?.total}: ${i?.name}`)
});